<!-- 查看视频 -->
<template>
  <div>
    <div  class="video">
      <video-player id="video"
                    @ended="onPlayerEnded"
        class="video-player vjs-custom-skin"
        :options="playerOptions"
        webkit-playsinline= "true"
        :playsinline= "true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        style="object-fit:fill"
      >
      </video-player>
             <!-- video-player-type="h5"
        video-player-fullscreen="true"
        video-orientation="landscape" -->
    </div>
    <div style="text-align: center;width:100%;margin-top: 20px">
      <el-button @click="exitHome" type="primary">
        返回
      </el-button>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'
let clientWidth = document.documentElement.clientWidth
export default {
  data () {
    return {
      playerOptions: {
        width: clientWidth > 1000 ? 1000 : clientWidth,
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4', // 类型
          src: '' // url地址
        }],
        poster: '', // 封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      }
    }
  },
  // 路由进来前
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.playerOptions.sources[0].src = vm.$route.query.src.path
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  },

  methods: {
    // 将用户已播放的视频更新存入到数据库
    updatePlayed (id) {
      let user = this.gmdss.user_info
      let list = this.gmdss.videoReadList
      if (list === null || list === undefined) {
        list = []
      }
      // eslint-disable-next-line eqeqeq
      if (list.indexOf(id) != -1) { // 防止重复看
        return
      }
      list.push(id)
      let msg = {}
      msg.id = user.id
      msg.videoId = id // 用户已播放的视频
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.updatePlayedfn
      sendData.vm = this
      req.Post('user/updatePlayed', sendData)
    },
    updatePlayedfn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
      this.gmdss.mustLearnVideo = this.gmdss.mustLearnVideo - 1
      this.$message.success('播放完成')
    },
    exitHome () {
      this.$router.push('/index')
    },
    // 播放回调
    onPlayerPlay (player) {
    },
    // 暂停回调
    onPlayerPause (player) {
    },
    // 视频播完回调
    onPlayerEnded ($event) {
      if (this.$route.query.src.state === 2) { // 只有必看视频才需要执行以下函数
        this.updatePlayed(this.$route.query.src.id)
      }
    },
    // DOM元素上的readyState更改导致播放停止
    onPlayerWaiting ($event) {
    },
    // 已开始播放回调
    onPlayerPlaying ($event) {
    },
    // 当播放器在当前播放位置下载数据时触发
    onPlayerLoadeddata ($event) {
    },
    // 当前播放位置发生变化时触发。
    onPlayerTimeupdate ($event) {
    },
    // 媒体的readyState为HAVE_FUTURE_DATA或更高
    onPlayerCanplay (player) {
      // console.log('player Canplay!', player)
    },
    // 媒体的readyState为HAVE_ENOUGH_DATA或更高。这意味着可以在不缓冲的情况下播放整个媒体文件。
    onPlayerCanplaythrough (player) {
      // console.log('player Canplaythrough!', player)
    },
    // 播放状态改变回调
    playerStateChanged (playerCurrentState) {
    },
    // 将侦听器绑定到组件的就绪状态。与事件监听器的不同之处在于，如果ready事件已经发生，它将立即触发该函数。。
    playerReadied (player) {
    }
  }

}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video{
  width: 100%;
  height: 100%;
  background: black;
  display:flex;
  justify-content:center;
  align-items: center;
}
.video_content{
  width: 100%;
  height: 80%;
}
#video {
  width: 80%;
}

</style>



// WEBPACK FOOTER //
// src/components/video.vue